module.exports = __webpack_public_path__ + "img/kiosk-terminals.c0759308.svg";